/* @flow */
export default {
  headerHeight: 64,
  topBarHeight: 48,
};

export const userRoleMeta = {
  accountant: { title: 'Bookkeeper', role: 'accountant' },
  'limited-accountant': { title: 'Limited Bookkeeper', role: 'limited-accountant' },
  'restricted-accountant': { title: 'Restricted Bookkeeper', role: 'restricted-accountant' },

  user: { title: 'Regular User', role: 'user' },
  'confidential-user': { title: 'Confidential User', role: 'confidential-user' },
  'restricted-user': { title: 'Restricted user', role: 'restricted-user' },
  'confidential-restricted-user': { title: 'Restricted Confidential User', role: 'confidential-restricted-user' },
};
